import { render, staticRenderFns } from "./LiquorMasterArea.vue?vue&type=template&id=38a90373&scoped=true&"
import script from "./LiquorMasterArea.vue?vue&type=script&lang=js&"
export * from "./LiquorMasterArea.vue?vue&type=script&lang=js&"
import style0 from "./LiquorMasterArea.vue?vue&type=style&index=0&id=38a90373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a90373",
  null
  
)

export default component.exports